import React, { useState } from "react";
import {
    saveAcPaymentData, saveVdsPaymentData,
    saveVriPaymentData,
    setAsDefaultPaymentMethod, startVDSFreeTrial,
    startVRIFreeTrial
} from "../../../api/requests";
import {PaymentElement} from "@stripe/react-stripe-js";
import BackButton from "../buttons/BackButton";
import SyncLoader from "react-spinners/SyncLoader";
import {PAYMENT_TYPE} from "../../../constants";

export const NewPaymentSection = ({type, stripe, elements, loading, setLoading, payNow,
                                      doNotRenew, paymentIntentId, handleSavePaymentDataResult,
                                      handleStartFreeTrialResult, selectedPlan, submitBtnText,
                                      addNewMode, setAddNewMode, isEligibleForFreeTrial, onBack}) => {
    const [error, setError] = useState(null);
    const [submitting, setSubmitting] = useState(false);

    if (!addNewMode) {
        return <></>;
    }

    const handleSubmit = async (event) => {
        event.preventDefault(); // Prevent default form submission.
        if (!stripe || !elements || !submitting) {
            return;
        }

        setLoading(true);

        const options = {
            //`Elements` instance that was used to create the Payment Element
            elements,
            confirmParams: {
                return_url: window.location.toString(),
            },
            redirect: 'if_required',
        };

        const result = payNow ? await stripe.confirmPayment(options) : await stripe.confirmSetup(options);
        const { error, paymentIntent, setupIntent } = result;
        let status = {};
        if (paymentIntent) {
            status = paymentIntent.status;
        } else if (setupIntent) {
            status = setupIntent.status;
        }

        if (error) {
            setLoading(false);
            setError(error.message);
            return;
        }

        if (error || status !== "succeeded") {
            if (type === PAYMENT_TYPE.VRI) {
                saveVriPaymentData(paymentIntentId, selectedPlan.value, doNotRenew, handleSavePaymentDataResult);
            } else if (type === PAYMENT_TYPE.VDS) {
                saveVdsPaymentData(paymentIntentId, selectedPlan.value, doNotRenew, handleSavePaymentDataResult);
            } else {
                saveAcPaymentData(paymentIntentId, doNotRenew, handleSavePaymentDataResult);
            }
            return;
        }

        if (paymentIntent) {
            stripe.retrievePaymentIntent(paymentIntent.client_secret).then(({paymentIntent}) => {
                if (type === PAYMENT_TYPE.VRI) {
                    saveVriPaymentData(paymentIntentId, selectedPlan.value, doNotRenew, handleSavePaymentDataResult);
                } else if (type === PAYMENT_TYPE.VDS) {
                    saveVdsPaymentData(paymentIntentId, selectedPlan.value, doNotRenew, handleSavePaymentDataResult);
                } else {
                    saveAcPaymentData(paymentIntentId, doNotRenew, handleSavePaymentDataResult);
                }
            });
        } else if (setupIntent) {
            stripe.retrieveSetupIntent(setupIntent.client_secret).then(({setupIntent}) => {
                if (isEligibleForFreeTrial && type === PAYMENT_TYPE.VRI) {
                    startVRIFreeTrial(selectedPlan.value, setupIntent.payment_method, handleStartFreeTrialResult);
                } else if (isEligibleForFreeTrial && type === PAYMENT_TYPE.VDS) {
                    startVDSFreeTrial(selectedPlan.value, setupIntent.payment_method, handleStartFreeTrialResult);
                } else {
                    setAsDefaultPaymentMethod(setupIntent.payment_method, handleSavePaymentDataResult);
                }
            });
        }
    };

    const onBackBtnClick = () => {
        if (setAddNewMode) {
            setAddNewMode(false);
        } else if (onBack) {
            onBack();
        }
    }

    return (
        <div className={'margin-top-1'}
             data-testid={`newPaymentSection-${type}`}>
            <form onSubmit={handleSubmit}>
                <div>
                    <PaymentElement onReady={() => setLoading(false)}/>
                    <div className={"flexSpaceBetween footerMargins"}>
                        <BackButton onClick={onBackBtnClick}
                                    disabled={loading || !stripe || !elements}
                                    hidden={loading}/>
                        <button className={"button-pay"}
                                data-testid={'submitNewPaymentBtn'}
                                onClick={() => {setSubmitting(true)}}
                                disabled={loading || !stripe || !elements}
                                hidden={loading}>{submitBtnText}</button>
                    </div>
                </div>
                {loading && (<div><SyncLoader /></div>)}
            </form>
        </div>
    );
}